import React from "react";

const ApiCatalogContext = React.createContext();

export default ApiCatalogContext;
